/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCalendarTimePicker/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Dropdown from './Dropdown/index'
import Modal from './Modal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaCalendarTimePicker({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarTimePicker",
  isNative,
  dayDate,
  from,
  isSelected,
  onClick,
  timezone
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!isNative}>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 dayDate={dayDate}
 from={from}
 isNative={isNative}
 isSelected={isSelected}
 onClick={onClick}
 timezone={timezone}
/>
</fromFlow.When>
<fromFlow.When is={isNative}>
<Modal
  viewPath={`${viewPath}/Modal`}
 dayDate={dayDate}
 from={from}
 isNative={isNative}
 isSelected={isSelected}
 onClick={onClick}
 timezone={timezone}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}